import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Tooltip as ReactTooltip } from "react-tooltip";

const roundToNearestHalf = (hrs) => Math.round(hrs / 0.5) * 0.5;

const TimesheetInput = ({
  rowIdx,
  onChangeInput,
  onEnterCallDetails,
  call,
  auth,
  disabled
}) => {
  const [value, setValue] = useState(undefined);
  useEffect(() => {
    setValue(call.actual_hrs);
  }, [call.actual_hrs]);

  // const isDisabled = useMemo(
  //   () =>
  //     disabled ||
  //     (call.stage && call.stage.order > 4) ||
  //     (auth.maxRole < 7000 &&
  //       call.assigned_to &&
  //       call.assigned_to._id !== auth.user._id),
  //   [auth.maxRole, auth.user._id, call.assigned_to, call.stage, disabled]
  // );

  const handleEnterCallDetails = (e) => {
    if (!disabled) onEnterCallDetails(e, rowIdx);
  };

  const handleChangeInput = (e) => {
    if (!disabled) {
      setValue(value);
      handleEnterCallDetails(e);
    }
  };

  const handleBlur = (e) => {
    const float = parseFloat(e.target.value);
    if (!Number.isNaN(float)) {
      const rounded = Math.max(roundToNearestHalf(float), 0);
      onChangeInput(call.day, rounded, rowIdx);
      setValue(rounded);
    } else if (e.target.value === "" && !!call._id) {
      onChangeInput(call.day, e.target.value, rowIdx);
    } else if (e.target.value === "") {
      onChangeInput(call.day, "", rowIdx, true);
    }
  };
  const handleKeyDown = (e) => {
    if ((e.keyCode === 68 || e.type === "click") && !disabled) {
      e.preventDefault();
      handleEnterCallDetails(e);
    }
  };

  return (
    <React.Fragment>
      <span
        className="hour-container"
        id={call._id}
        data-tooltip-variant={auth.isNightMode ? "dark" : "light"}
        data-html
      >
        <input
          className={`form-control time-field ${call.error ? "is-error" : ""} ${
            typeof value !== "undefined" && !call.internal_notes
              ? "is-error"
              : ""
          } ${!disabled ? "pointer" : "not-allowed"}`}
          name={call.day}
          onKeyDown={handleKeyDown}
          onKeyUp={handleKeyDown}
          onClick={handleKeyDown}
          onChange={handleChangeInput}
          value={value}
          disabled={disabled}
          onBlur={handleBlur}
        />
      </span>
      <ReactTooltip
        anchorId={call._id}
        place="left"
        type={auth.isNightMode ? "dark" : "light"}
        effect="solid"
        className={`call-tooltip custom-tooltip ${
          auth.isNightMode ? "dark" : "light"
        }`}
        globalEventOff="click"
        data-html
        insecure
        multiline
      >
        <p style={{ fontSize: 13, fontFamily: "Nunito" }}>
          {call.internal_notes || ""}
        </p>
      </ReactTooltip>
    </React.Fragment>
  );
};

TimesheetInput.propTypes = {
  rowIdx: PropTypes.number,
  onChangeInput: PropTypes.func,
  onEnterCallDetails: PropTypes.func,
  call: PropTypes.object,
  auth: PropTypes.object,
  disabled: PropTypes.bool
};

TimesheetInput.defaultProps = {
  disabled: false
};

export default TimesheetInput;
